module.exports = "/packs/images/sprites/footer_new~bc9d70500aac4c3782c3b4e581c8b58a.png";